import React from 'react';
import styles from '../styles.module.css';

const ToolbarArea = ({ children }) => {
  return <div className={styles.toolbarArea}>{children}</div>;
};

export default ToolbarArea;
